export function smartFormat (values, options = {}) {
    const locale = options.locale || 'en-US';

    const listFormatter = new Intl.ListFormat(locale, {
        style: 'long',
        type: 'conjunction',
    });

    const numberFormatter = new Intl.NumberFormat(locale);

    const pluralRules = new Intl.PluralRules(locale);

    const isUnitObject = (val) => val && typeof val === 'object' && 'value' in val && 'unit' in val;

    if (Array.isArray(values)) {
        // Handle list of unit objects or raw numbers
        const isAllUnits = values.every(isUnitObject);

        if (isAllUnits) {
            // Format like: ["3 days", "12 hours", "31 minutes"]
            const formatted = values.map(({ value, unit }) => {
                const plural = pluralRules.select(value);
                const unitLabel = plural === 'one' ? unit : `${unit}s`;

                return `${numberFormatter.format(value)} ${unitLabel}`;
            });

            return listFormatter.format(formatted);
        }

        // Assume raw numbers like [1000, 20000, 19000000]
        return listFormatter.format(values.map((val) => numberFormatter.format(val)));
    }
    if (isUnitObject(values)) {
        const { value, unit } = values;
        const plural = pluralRules.select(value);
        const unitLabel = plural === 'one' ? unit : `${unit}s`;

        return `${numberFormatter.format(value)} ${unitLabel}`;
    }
    if (typeof values === 'number') {
        return numberFormatter.format(values);
    }

    throw new Error('Unsupported format input');
}

export function formatSmartPercentage (percentValue, options = {}) {
    const locale = options.locale || 'en-US';

    const useTwoDecimals = percentValue > 0 && percentValue < 1;

    const formatter = new Intl.NumberFormat(locale, {
        style: 'percent',
        minimumFractionDigits: useTwoDecimals ? 1 : 0,
        maximumFractionDigits: useTwoDecimals ? 2 : 0,
    });

    return formatter.format(percentValue / 100);
}

export function formatSmartMoney (moneyValue, options = {}) {
    const locale = options.locale || 'en-US';

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: options.currency || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    return formatter.format(moneyValue);
}

export function formatTimeToComplete (timeToComplete) {
    if (timeToComplete === null) {
        return '0';
    }
    const timeToCompleteDays = Math.floor(timeToComplete / (24 * 60 * 60 * 1000));
    const timeToCompleteDaysMs = timeToComplete % (24 * 60 * 60 * 1000);
    const timeToCompleteHours = Math.floor(timeToCompleteDaysMs / (60 * 60 * 1000));
    const timeToCompleteHoursMs = timeToCompleteDaysMs % (60 * 60 * 1000);
    const timeToCompleteMinutes = Math.floor(timeToCompleteHoursMs / (60 * 1000));

    const formattedStrings = [];

    if (timeToCompleteDays) {
        formattedStrings.push({
            value: timeToCompleteDays,
            unit: 'day',
        });
    }
    if (timeToCompleteHours) {
        formattedStrings.push({
            value: timeToCompleteHours,
            unit: 'hour',
        });
    }
    if (timeToCompleteMinutes) {
        formattedStrings.push({
            value: timeToCompleteMinutes,
            unit: 'minute',
        });
    }

    return smartFormat(formattedStrings);
}
